/**
 * Validates if the provided string matches Canadian postal code format
 * Format: A1A 1A1 (with or without space)
 * @param postalCode - The postal code string to validate
 * @returns true if valid Canadian postal code format, false otherwise
 */
export function validateCanadianPostalCode(postalCode: string): boolean {
  if (!postalCode) return false;

  // Canadian postal code format: A1A 1A1 (letter-digit-letter space digit-letter-digit)
  // Accepts with or without space, case-insensitive
  const canadianPostalCodeRegex = /^[A-Z]\d[A-Z]\s?\d[A-Z]\d$/i;
  return canadianPostalCodeRegex.test(postalCode.trim());
}

/**
 * Formats a Canadian postal code to standard format (A1A 1A1)
 * Removes extra spaces, converts to uppercase, adds space in the middle
 * @param postalCode - The postal code string to format
 * @returns Formatted postal code or original if invalid format
 */
export function formatCanadianPostalCode(postalCode: string): string {
  if (!postalCode) return postalCode;

  const cleaned = postalCode.replace(/\s/g, "").toUpperCase();

  // If cleaned version is 6 characters, format as A1A 1A1
  if (cleaned.length === 6) {
    return `${cleaned.slice(0, 3)} ${cleaned.slice(3)}`;
  }

  return postalCode;
}
